<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M12.75 1.5C13.7165 1.5 14.5 2.2835 14.5 3.25C14.5 3.94772 14.0907 4.54804 13.5 4.8291V11.1699C14.0909 11.4509 14.5 12.0521 14.5 12.75C14.5 13.7165 13.7165 14.5 12.75 14.5C12.0523 14.5 11.452 14.0907 11.1709 13.5H4.8291C4.54804 14.0907 3.94772 14.5 3.25 14.5C2.2835 14.5 1.5 13.7165 1.5 12.75C1.5 12.0521 1.90908 11.4509 2.5 11.1699V4.8291C1.90928 4.54804 1.5 3.94772 1.5 3.25C1.5 2.2835 2.2835 1.5 3.25 1.5C3.94772 1.5 4.54804 1.90928 4.8291 2.5H11.1709C11.452 1.90928 12.0523 1.5 12.75 1.5ZM4.8291 4C4.65631 4.36316 4.36316 4.65631 4 4.8291V11.1699C4.36333 11.3427 4.65625 11.6367 4.8291 12H11.1709C11.3437 11.6367 11.6367 11.3427 12 11.1699V4.8291C11.6368 4.65631 11.3437 4.36316 11.1709 4H4.8291Z"
    fill="currentColor"
  />
</svg>
